/* unplugin-vue-components disabled */import script from "./RecurrenceSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./RecurrenceSelector.vue?vue&type=script&setup=true&lang=js"

import "./RecurrenceSelector.vue?vue&type=style&index=0&id=508f0061&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-508f0061"]])

export default __exports__